import useSWR from "swr";

import { deliveriesServices } from "../../../../../helpers/services/DeliveriesServices";
import { supplierServices } from "../../../../../helpers/services/SupplierServices";
import { ResponseStatusEnum, RolesEnum } from "../../../../../helpers/GlobalEnum";

/** Roles que consultan el catálogo completo de proveedores del titular. */
const CATALOG_ROLES = [
    RolesEnum.TERRITORIAL_LINKS,
    RolesEnum.ADMIN,
    RolesEnum.SUPERVISION,
];

/**
 * Consulta los proveedores asociados a un titular (CUB).
 * GET /api/entrega/proveedores/{cubId}/
 */
const fetchSuppliers = async (cubId) => {
    const { data, status } = await deliveriesServices.getSuppliers(cubId);
    if (status !== ResponseStatusEnum.OK || !Array.isArray(data)) return [];
    return data;
};

/**
 * Provee la lista de proveedores para el selector de creación de entregas.
 * - ADMIN / TERRITORIAL_LINKS / SUPERVISION → catálogo completo del titular (SWR, cacheado).
 * - SUPPLIER → único proveedor derivado del token (sin request).
 * - Otros roles → lista vacía.
 *
 * @param {number|string} cubId - ID del titular (CUB).
 * @param {number} rolId - Rol del usuario autenticado.
 */
export function useSuppliers(cubId, rolId) {
    const isCatalogRole = CATALOG_ROLES.includes(rolId);

    const { data = [], isLoading } = useSWR(
        cubId && isCatalogRole ? ["suppliers", cubId] : null,
        () => fetchSuppliers(cubId),
        { revalidateOnFocus: false, dedupingInterval: 5000, keepPreviousData: true }
    );

    if (rolId === RolesEnum.SUPPLIER) {
        const supplierId = supplierServices.getSupplierId();
        return { suppliers: supplierId != null ? [{ id: supplierId }] : [], isLoading: false };
    }

    return { suppliers: isCatalogRole ? data : [], isLoading: isCatalogRole ? isLoading : false };
}